
import {Vue,Prop} from "vue-property-decorator";
import Datetimepicker from "@/apps/rever-academy/components/Datetimepicker.vue";

const $ = require('jquery')
import 'owl.carousel';
// import 'owl.carousel'

export default class OwlCarousel extends Vue{
  // name: 'owl-carousel',
  // props: {
  //   options: {
  //     type: Object,
  //     default: function () {
  //       return {}
  //     }
  //   }
  // }
  @Prop({ type:Object, default : {} }) options! : any
  @Prop({ type:Number}) items! : number | undefined

  mounted() {
    console.log("owl carousel ",this.$el)
    console.log(this.items)
    if(this.items !== undefined)
      this.options.responsive =  {
      0: {
        items: 1
      },
      768: {
        items: this.items >= 2 ? 2 : 1
      },
      1000: {
        items: this.items
      }
    }
    this.$nextTick(() => {
      $(this.$el).owlCarousel(this.options)
    })
  }
}

// export default {
//   name: 'owl-carousel',
//   props: {
//     options: {
//       type: Object,
//       default: function () {
//         return {}
//       }
//     }
//   },
//   mounted() {
//     this.$nextTick(() => {
//       $(this.$el).owlCarousel(this.options)
//     })
//   }
// }
